'use client';
import { twMerge } from 'tailwind-merge';

import { inTransitDefaultImageUrl } from '@/constants/inventory';
import { GridInventory } from '@lamesarv-sdk/inventory';
import { convertSort } from '@lamesarv-sdk/tools';

import { IBasicInventory, IComponentGridInventory, IMetaData, InventoryField } from '@lamesarv-sdk/types';

import { InventoryItem } from './InventoryItem';

export const inventoryGridClassName = 'gap-x-2 min-[990px]:!grid-cols-2 min-[1380px]:!grid-cols-3';

interface InventoryGridProps extends IComponentGridInventory {
  metadata: IMetaData;
  sort?: string;
}

export const InventoryGrid = (props: InventoryGridProps) => {
  const convertedSort = !!props?.extraData?.sort ? convertSort(props.extraData.sort) : undefined;

  return (
    <GridInventory
      {...props}
      sort={convertedSort || `${InventoryField.order}:asc`}
      defaultImageUrl={inTransitDefaultImageUrl}
      CustomInventoryItem={(item: IBasicInventory) => <InventoryItem item={item} />}
      className={twMerge(inventoryGridClassName, props.className)}
    />
  );
};
